/**
 * Labstep
 *
 * @module app
 * @desc Mount the app with hot reload module
 */

import 'reflect-metadata';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ErrorBoundaryContainer } from './labstep-web/containers/ErrorBoundary';
import './labstep-web/scss/index.scss';
import { LayoutFullPageError as FullPageError } from 'labstep-web/components/Layout/FullPageError';
import App from './labstep-web/components/App';
import { APP_VERSION } from './labstep-web/constants/version';
import { configService } from './labstep-web/services/config.service';
import { setupDropHandler } from './labstep-web/services/drop.service';
import store from './labstep-web/state/store';

// Initalises drop handler, services initialised in services/ErrorBoundaries
setupDropHandler();

// Log app version, commit hash and window.location
console.log('Commit hash is', configService.commitHash);
console.log('App version is', APP_VERSION);
console.log('window.location is', window.location);

// Handle mounting the root level component (bootstrap the application)
const mount = (Component: () => JSX.Element) => {
  const container = document.getElementById('root') as HTMLElement;

  // Initialize store

  // eslint-disable-next-line no-inner-declarations
  function Root() {
    return (
      <ErrorBoundaryContainer FallbackComponent={<FullPageError />}>
        <Provider store={store}>
          <Component />
        </Provider>
      </ErrorBoundaryContainer>
    );
  }

  const root = createRoot(container); // createRoot(container!) if you use TypeScript

  root.render(<Root />);

  // if (module.hot) {
  //   module.hot.accept(Component as any, () => {
  //     render((<Root />) as any, mountElement);
  //   });
  // }
};

mount(App);
